import {Injectable} from '@angular/core';
import {SettingENUM} from '../enums/setting.enum';
import {PersonType} from '../enums/person-type.enum';
import {ModuleENUM} from '../enums/module.enum';
import {FileService} from '../../modules/shared/services/file.service';
import {Utils} from './Utils';
import {Language} from '../models/language';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class Principal {

  private user: any = null;

  constructor(private _fileService: FileService,
              private _utils: Utils,
              private _http: HttpClient) {
    if (!this.user) {
      this.getUser();
    }
  }

  getUser() {
    if (!this.user) {
      let v = localStorage.getItem(`${SettingENUM.TOKEN_STR}_user`);
      if (v) {
        try {
          v = this._utils.decryptAES(v);
          this.user = JSON.parse(v);
          this.initAccessModules();
        } catch (e) {
        }
      } else {
        return null;
      }
      if (this.getAccessByModuleId(ModuleENUM.ADMIN)) {
        this.user.personType = PersonType.ADMINISTRATOR;
      } else if (this.getAccessByModuleId(ModuleENUM.MODERATOR)) {
        this.user.personType = PersonType.MODERATOR;
      } else if (this.getAccessByModuleId(ModuleENUM.ADMIN_REGION)) {
        this.user.personType = PersonType.REGION_ADMINISTRATOR;
      } else if (this.getAccessByModuleId(ModuleENUM.ENROLL)) {
        this.user.personType = PersonType.ENROLL;
      } else {
        this.user.personType = PersonType.USER;
      }
    }
    return this.user;
  }

  /*
  iz zatogo chto service v lazy load moduleh, set user = null, ne izmeniat drugom module;
   */
  reloadUserData() {

    this.user = null;
    const token = localStorage.getItem(`${SettingENUM.TOKEN_STR}`);
    let v = localStorage.getItem(`${SettingENUM.TOKEN_STR}_user`);
    if (v) {
      try {
        v = this._utils.decryptAES(v);
        this.user = JSON.parse(v);
        // console.log('Principal setUser', this.user);
        this.initAccessModules();
        this.initProfilePhoto();
        if (this.getAccessByModuleId(ModuleENUM.ADMIN)) {
          this.user.personType = PersonType.ADMINISTRATOR;
        } else if (this.getAccessByModuleId(ModuleENUM.MODERATOR)) {
          this.user.personType = PersonType.MODERATOR;
        } else if (this.getAccessByModuleId(ModuleENUM.ADMIN_REGION)) {
          this.user.personType = PersonType.REGION_ADMINISTRATOR;
        } else if (this.getAccessByModuleId(ModuleENUM.ENROLL)) {
          this.user.personType = PersonType.ENROLL;
        } else {
          this.user.personType = PersonType.USER;
        }
      } catch (e) {
      }

    } else {
      return null;
    }
  }

  initProfilePhoto() {
    if (!this.user.profilePhoto) {
      if (this.user.profilePhotoId && this.user.profilePhotoId.length === 24) {
        const reader = new FileReader();
        this._fileService.getFile(this.user.profilePhotoId).subscribe(
          response => {
            reader.addEventListener('load', () => {
              this.user.profilePhoto = reader.result;
            }, false);
            reader.readAsDataURL(response);
          }
        );
      }
    }
  }

  getUserId() {
    if (this.user) {
      return this.user.id;
    }
  }

  setUserProfilePhoto(photo: string) {
    if (this.user) {
      this.user.profilePhoto = photo;
    }
  }

  getUserCollegeId() {
    if (this.user && this.user.positionType) {
      if (this.user.positionType.id == 1 && this.user.collegeId) {
        return this.user.collegeId;
      }
    }
    return null;
  }

  getUserRegionId() {
    if (this.user) {
      return this.user['region'];
    }
    return 0;
  }

  setTokenAndUser(token, user) {
    this.user = user;
    this.initAccessModules();
    localStorage.setItem(`${SettingENUM.TOKEN_STR}`, token);
    localStorage.setItem(`clientID`, this.generateUUID());
    localStorage.setItem(`${SettingENUM.TOKEN_STR}_user`, this._utils.encryptAES(JSON.stringify(user)));
    localStorage.setItem(`${SettingENUM.REGION_ID}`, user['region']);
    // localStorage.setItem(`${SettingENUM.TOKEN_STR}_user`, JSON.stringify(user));
    this.initProfilePhoto();
    if (this.getAccessByModuleId(ModuleENUM.ADMIN)) {
      this.user.personType = PersonType.ADMINISTRATOR;
    } else if (this.getAccessByModuleId(ModuleENUM.MODERATOR)) {
      this.user.personType = PersonType.MODERATOR;
    } else if (this.getAccessByModuleId(ModuleENUM.ADMIN_REGION)) {
      this.user.personType = PersonType.REGION_ADMINISTRATOR;
    } else if (this.getAccessByModuleId(ModuleENUM.ENROLL)) {
      this.user.personType = PersonType.ENROLL;
    } else {
      this.user.personType = PersonType.USER;
    }
  }

  deleteTokenAndUser() {
    const currentLanguageCode = localStorage.getItem(Language.SYSTEM_LANGUAGE_CODE_LABEL);
    localStorage.clear();
    this.user = null;
    localStorage.setItem(Language.SYSTEM_LANGUAGE_CODE_LABEL, currentLanguageCode);
  }

  isLoggedIn() {
    if (!this.user) {
      this.getUser();
    }
    return this.user && localStorage.getItem(`${SettingENUM.TOKEN_STR}`);
  }

  isLoggedInFromBackend() {
    if (localStorage.getItem(`${SettingENUM.TOKEN_STR}`)) {
      this._http.get(`api/user/current`, {headers: {'Authorization': `Bearer ${localStorage.getItem(`${SettingENUM.TOKEN_STR}`)}`}}).subscribe(
        userDTO => {
          localStorage.setItem(`${SettingENUM.REGION_ID}`, userDTO['region']);
          return true;
        }, error => {
          this.deleteTokenAndUser();
          console.log('api/user/current error', error)
          return false;
        });
    }
  }

  isAdmin() {
    return this.user && this.user.personType === PersonType.ADMINISTRATOR;
  }

  isModerator() {
    return this.user && this.user.personType === PersonType.MODERATOR;
  }

  isRegionAdmin() {
    return this.user && this.user.personType === PersonType.REGION_ADMINISTRATOR;
  }

  isUser() {
    return this.user && this.user.personType === PersonType.USER;
  }
  isEnroll() {
    return this.user && this.getAccessByModuleId(ModuleENUM.ENROLL);
  }

  private initAccessModules() {
    this.user.accessModules = {};
    if (this.user && this.user.roleList) {
      for (let i = 0; i < this.user.roleList.length; i++) {
        for (let k = 0; k < this.user.roleList[i].permissions.length; k++) {
          const moduleCode = this.user.roleList[i].permissions[k].module.code.toUpperCase();
          this.user.accessModules[moduleCode] = this.user.roleList[i].permissions[k];
        }
      }
    }
  }

  getAccessByModuleId(moduleCode) {
    if (!this.user) {
      this.getUser();
    }
    if (!localStorage.getItem(`${SettingENUM.TOKEN_STR}`)) {
      return;
    }
    if (this.user && this.user.roleList) {
      for (let i = 0; i < this.user.roleList.length; i++) {
        for (let k = 0; k < this.user.roleList[i].permissions.length; k++) {
          if (this.user.roleList[i].permissions[k].module
            && moduleCode === this.user.roleList[i].permissions[k].module.code.toUpperCase()) {
            this.user.accessModules[moduleCode] = this.user.roleList[i].permissions[k];
            return this.user.roleList[i].permissions[k];
          }
        }
      }
    }
    return false;
  }

  getExtAccessByModuleCodeAndAccessCode(moduleCode: string, accessCode: string): any {
    const access = this.user.accessModules[moduleCode];
    if (access) {
      for (let i = 0; i < access.moduleExtendedAccesses.length; i++) {
        const mea = access.moduleExtendedAccesses[i].moduleExtendedAccess;
        if (mea.code === accessCode) {
          return access.moduleExtendedAccesses[i].objectIds;
        }
      }
    }
    return null;
  }

  getRoleByModuleId(moduleCode) {
    if (!this.user) {
      this.getUser();
    }
    if (!localStorage.getItem(`${SettingENUM.TOKEN_STR}`)) {
      return;
    }
    if (this.user && this.user.roleList) {
      for (let i = 0; i < this.user.roleList.length; i++) {
        for (let k = 0; k < this.user.roleList[i].permissions.length; k++) {
          if (this.user.roleList[i].permissions[k].module
            && moduleCode === this.user.roleList[i].permissions[k].module.code.toUpperCase()) {
            this.user.accessModules[moduleCode] = this.user.roleList[i].permissions[k];
            return this.user.roleList[i];
          }
        }
      }
    }
    return false;
  }

  getExtEditList(moduleCode: string): number[] {
    const roles = this.getUserRoleList();
    const extEditSet: Set<number> = new Set();
    for (let i = 0; i < roles.length; i++) {
      for (let k = 0; k < roles[i].permissions.length; k++) {
        if (roles[i].permissions[k].module && moduleCode === roles[i].permissions[k].module.code) {
          const edits = roles[i].permissions[k].moduleExtendedEdits;
          for (let j = 0; j < edits.length; j++) {
            if (edits[j].selected) {
              extEditSet.add(edits[j].extendedEdit.id);
            }
          }
        }
      }
    }
    return Array.from(extEditSet);
  }

  hasWriteAccess(moduleCode: string): boolean {
    let hasWriteAccess = false;
    const roles = this.getUserRoleList();
    for (let i = 0; i < roles.length; i++) {
      for (let k = 0; k < roles[i].permissions.length; k++) {
        if (roles[i].permissions[k].module && moduleCode === roles[i].permissions[k].module.code) {
          hasWriteAccess = hasWriteAccess || roles[i].permissions[k].editable;
        }
      }
    }
    return hasWriteAccess;
  }

  hasModuleExtendedEdit(module, extendedEditId) {
    let result = false;
    if (this.user && this.user['accessModules'] && this.user['accessModules'][module]) {
      const extended = this.user['accessModules'][module]['moduleExtendedEdits'];
      if (extended && extended.length) {
        extended.forEach(e => {
          if (e['extendedEdit'] && e['extendedEdit']['id'] === extendedEditId) {
            result = e['selected'];
          }
        });
      }
    }
    return result;
  }

  getUserRoleList(): any[] {
    if (!this.user) {
      this.getUser();
    }
    if (!localStorage.getItem(`${SettingENUM.TOKEN_STR}`)) {
      return [];
    }
    if (this.user) {
      return this.user.roleList;
    }
    return [];
  }

  generateUUID() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/principal.ts